import {useCallback, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/helpers-css-strings";
import {CloseIcon, DownloadIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {AuthModalVariant} from "../../../auth/components/auth_modal/AuthModalHeaderVariants";
import {startRegistrationFlowVariantB} from "../../../auth/state/registration_flow_variantB_slice";
import {useShouldHidePrices} from "../../../hooks/use_should_hide_prices";
import {useAppDispatch} from "../../../store/hooks";
import {gtmOfferGalleryEvents} from "../../../tracking/google_tag_manager/gtm_event_offer_gallery_modal";
import {gtmEventPropertyDownloadPlanRegister} from "../../../tracking/google_tag_manager/gtm_event_property_download_plan_register";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {OfferModalActiveTab} from "../../types/OfferModalActiveTab";
import {GalleryHolderPropertyPlanAuthConfirmationModal} from "./GalleryHolderPropertyPlanAuthConfirmationModal";
import {usePlanDownloadModal} from "./use_plan_download_modal";

interface IProps {
    propertyPlan: string;
    onPlanButtonClick: () => void;
    modalState?: OfferModalActiveTab | null;
    propertyId?: number;
    offerId?: number;
}

export const GalleryHolderPropertyPlanButton = (props: IProps) => {
    const {onPlanButtonClick, propertyPlan, modalState, propertyId, offerId} = props;

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    const dispatch = useAppDispatch();
    const {hasPhoneVerified, hasCompleteProfile, isUserLoggedIn} = useShouldHidePrices();
    const allowForPlanDownload = hasPhoneVerified && hasCompleteProfile;

    const handleFlowComplete = useCallback(() => {
        setShowConfirmationModal(true);
    }, []);

    usePlanDownloadModal(handleFlowComplete);

    const onModalClose = () => {
        setShowConfirmationModal(false);
    };

    const onButtonClick = () => {
        modalState && gtmOfferGalleryEvents.onPlanDownloadButton(modalState);
        if (allowForPlanDownload) {
            onPlanButtonClick();
        } else {
            dispatch(
                startRegistrationFlowVariantB({
                    hasCompleteProfile,
                    hasPhoneVerified,
                    isUserLoggedIn,
                    userSource: UserSource.REGISTER_PROPERTY_PLAN,
                    propertyId,
                    offerId,
                    modalVariant: "hidden_prices_variant_b",
                    titleVariant: AuthModalVariant.PROPERTY_PLAN_DOWNLOAD
                })
            );
            gtmEventPropertyDownloadPlanRegister();
        }
    };

    return (
        <>
            <div className={downloadButtonWrapperStyle}>
                <Button
                    className={buttonStyle}
                    variant="filled_primary"
                    href={allowForPlanDownload ? propertyPlan : undefined}
                    onClick={onButtonClick}
                    iconLeft={DownloadIcon}
                    target="_blank"
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.DOWNLOAD_PLAN_FROM_GALLERY}
                >
                    Pobierz rzut
                </Button>
            </div>

            {allowForPlanDownload && (
                <Modal
                    isOpen={showConfirmationModal}
                    onModalClose={onModalClose}
                    closeButton={(closeModal) => <CloseIcon size="2" wrapperSize="4.8" onClick={closeModal} className={closeButtonStyle} />}
                    className={modalStyle}
                >
                    <Modal.CloseButton placement="right" />

                    <Modal.Content className={modalContentStyle}>
                        <GalleryHolderPropertyPlanAuthConfirmationModal downloadButtonClick={onPlanButtonClick} propertyPlan={propertyPlan} />
                    </Modal.Content>
                </Modal>
            )}
        </>
    );
};

const downloadButtonWrapperStyle = css({
    md: {
        display: "flex",
        justifyContent: "center",
        mt: 3,
        mb: 1,
        width: "100%",
        my: 3,
        textAlign: "center"
    }
});

const buttonStyle = css({
    width: "100%",
    md: {
        width: "auto"
    }
});

const modalStyle = css({
    zIndex: 10000,
    bottom: 0,
    borderRadius: 2,
    overflow: "auto",
    width: "100%",
    maxHeight: "100dvh",
    md: {
        bottom: "unset",
        maxWidth: "500px",
        maxHeight: "calc(100dvh - 8rem)"
    }
});

const modalContentStyle = css({
    width: "100%",
    md: {
        borderRadius: 2
    }
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: -7,
    boxShadow: elevation(),
    md: {
        top: -3,
        right: -3,
        transform: "unset",
        boxShadow: elevation()
    }
});
import {useCallback, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/helpers-css-strings";
import {CloseIcon, DownloadIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {AuthModalVariant} from "../../../auth/components/auth_modal/AuthModalHeaderVariants";
import {startRegistrationFlowVariantB} from "../../../auth/state/registration_flow_variantB_slice";
import {useShouldHidePrices} from "../../../hooks/use_should_hide_prices";
import {useAppDispatch} from "../../../store/hooks";
import {gtmOfferGalleryEvents} from "../../../tracking/google_tag_manager/gtm_event_offer_gallery_modal";
import {gtmEventPropertyDownloadPlanRegister} from "../../../tracking/google_tag_manager/gtm_event_property_download_plan_register";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {OfferModalActiveTab} from "../../types/OfferModalActiveTab";
import {GalleryHolderPropertyPlanAuthConfirmationModal} from "./GalleryHolderPropertyPlanAuthConfirmationModal";
import {usePlanDownloadModal} from "./use_plan_download_modal";

interface IProps {
    propertyPlan: string;
    onPlanButtonClick: () => void;
    modalState?: OfferModalActiveTab | null;
    propertyId?: number;
    offerId?: number;
}

export const GalleryHolderPropertyPlanButton = (props: IProps) => {
    const {onPlanButtonClick, propertyPlan, modalState, propertyId, offerId} = props;

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    const dispatch = useAppDispatch();
    const {hasPhoneVerified, hasCompleteProfile, isUserLoggedIn} = useShouldHidePrices();
    const allowForPlanDownload = hasPhoneVerified && hasCompleteProfile;

    const handleFlowComplete = useCallback(() => {
        setShowConfirmationModal(true);
    }, []);

    usePlanDownloadModal(handleFlowComplete);

    const onModalClose = () => {
        setShowConfirmationModal(false);
    };

    const onButtonClick = () => {
        modalState && gtmOfferGalleryEvents.onPlanDownloadButton(modalState);
        if (allowForPlanDownload) {
            onPlanButtonClick();
        } else {
            dispatch(
                startRegistrationFlowVariantB({
                    hasCompleteProfile,
                    hasPhoneVerified,
                    isUserLoggedIn,
                    userSource: UserSource.REGISTER_PROPERTY_PLAN,
                    propertyId,
                    offerId,
                    modalVariant: "hidden_prices_variant_b",
                    titleVariant: AuthModalVariant.PROPERTY_PLAN_DOWNLOAD
                })
            );
            gtmEventPropertyDownloadPlanRegister();
        }
    };

    return (
        <>
            <div className={downloadButtonWrapperStyle}>
                <Button
                    className={buttonStyle}
                    variant="filled_primary"
                    href={allowForPlanDownload ? propertyPlan : undefined}
                    onClick={onButtonClick}
                    iconLeft={DownloadIcon}
                    target="_blank"
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.DOWNLOAD_PLAN_FROM_GALLERY}
                >
                    Pobierz rzut
                </Button>
            </div>

            {allowForPlanDownload && (
                <Modal
                    isOpen={showConfirmationModal}
                    onModalClose={onModalClose}
                    closeButton={(closeModal) => <CloseIcon size="2" wrapperSize="4.8" onClick={closeModal} className={closeButtonStyle} />}
                    className={modalStyle}
                >
                    <Modal.CloseButton placement="right" />

                    <Modal.Content className={modalContentStyle}>
                        <GalleryHolderPropertyPlanAuthConfirmationModal downloadButtonClick={onPlanButtonClick} propertyPlan={propertyPlan} />
                    </Modal.Content>
                </Modal>
            )}
        </>
    );
};

const downloadButtonWrapperStyle = css({
    md: {
        display: "flex",
        justifyContent: "center",
        mt: 3,
        mb: 1,
        width: "100%",
        my: 3,
        textAlign: "center"
    }
});

const buttonStyle = css({
    width: "100%",
    md: {
        width: "auto"
    }
});

const modalStyle = css({
    zIndex: 10000,
    bottom: 0,
    borderRadius: 2,
    overflow: "auto",
    width: "100%",
    maxHeight: "100dvh",
    md: {
        bottom: "unset",
        maxWidth: "500px",
        maxHeight: "calc(100dvh - 8rem)"
    }
});

const modalContentStyle = css({
    width: "100%",
    md: {
        borderRadius: 2
    }
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: -7,
    boxShadow: elevation(),
    md: {
        top: -3,
        right: -3,
        transform: "unset",
        boxShadow: elevation()
    }
});
